import axios from 'axios';

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
api.interceptors.request.use(config => {
  const token = localStorage.getItem('dispatch-token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
export const errorMessage = error => {
  const detail = error.response?.data?.detail;
  return typeof detail === 'string' ? detail : Array.isArray(detail) ? detail.map(d=>d.msg).join('. ') : 'Connection interrupted. Please try again.';
};
export const time = seconds => `${Math.floor((seconds || 0) / 60).toString().padStart(2,'0')}:${Math.floor((seconds || 0) % 60).toString().padStart(2,'0')}`;
export const clock = timestamp => new Date(timestamp * 1000).toLocaleTimeString('en-GB', { hour12: false });
export const rank = xp => xp >= 2400 ? 'Communications Supervisor' : xp >= 1400 ? 'Shift Dispatcher' : xp >= 800 ? 'Senior Dispatcher' : xp >= 300 ? 'Dispatcher' : 'Trainee Dispatcher';
export const colors = {Police:'#6995ff', Fire:'#f1a45d', EMS:'#4dceb3', SWAT:'#d4a2ac',Command:'#c8bd89','Special Operations':'#8dbdcc',Dispatch:'#a1b0bf', Supervisor:'#d5b56a', 'Multi-agency':'#e77676'};
export const closedStatuses=['Resolved','Transferred','False Report','Closed'];
export const cityNames = {pine:'Pine Valley', river:'River County', metro:'Metro County', mountain:'Mountain County'};
export const disclaimer = 'DISPATCH COMMAND is a fictional simulation game. This application is not connected to emergency services and should not be used to request emergency assistance.';
